// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__UZqdl"};